import { render, staticRenderFns } from "./search-results.vue?vue&type=template&id=515eaacf&shadow"
import script from "./search-results.vue?vue&type=script&lang=js&shadow"
export * from "./search-results.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports